import { useCallback } from 'react';
import { IResearchTeam, IResearchTeamMemberDetail } from '@vivli/features/data-requests/infrastructure/interface';

// DEV-541: lead researcher / statistician are derived from the research-team list (the
// isLeadResearcher / isStatistician member), not read from the inadvertently-persisted
// leadResearcherTeamMemberDetail / statisticianTeamMemberDetail snapshot on the data request.
export function useResearchTeamMembers() {
    const getLeadResearcher = useCallback(
        (researchTeam?: IResearchTeam): IResearchTeamMemberDetail | undefined =>
            researchTeam?.researchTeamDetails?.find((m) => m.isLeadResearcher),
        []
    );

    const getStatistician = useCallback(
        (researchTeam?: IResearchTeam): IResearchTeamMemberDetail | undefined =>
            researchTeam?.researchTeamDetails?.find((m) => m.isStatistician),
        []
    );

    return { getLeadResearcher, getStatistician };
}
